"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Alert = void 0;
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
require("./alert.css");
const React = tslib_1.__importStar(require("react"));
const react_1 = require("react");
const classnames_1 = tslib_1.__importDefault(require("classnames"));
const hooks_1 = require("@nbc-design/hooks");
const AttentionFilled_1 = require("@nbc-design/icons/lib/web/AttentionFilled");
const AttentionFilledXsmall_1 = require("@nbc-design/icons/lib/web/AttentionFilledXsmall");
const Close_1 = require("@nbc-design/icons/lib/web/Close");
const ErrorFieldFilled_1 = require("@nbc-design/icons/lib/web/ErrorFieldFilled");
const FailureFilledXsmall_1 = require("@nbc-design/icons/lib/web/FailureFilledXsmall");
const InfoFill_1 = require("@nbc-design/icons/lib/web/InfoFill");
const InformationFilledXsmall_1 = require("@nbc-design/icons/lib/web/InformationFilledXsmall");
const SuccessFilled_1 = require("@nbc-design/icons/lib/web/SuccessFilled");
const SuccessFilledXsmall_1 = require("@nbc-design/icons/lib/web/SuccessFilledXsmall");
const link_1 = require("@nbc-design/link");
const tokens_json_1 = tslib_1.__importDefault(require("@nbc-design/tokens/dist/styles/tokens.json"));
/** Alerts are used to display a inline status in a page. */
const Alert = ({ title, description, children, appearance = 'information', size = 'normal', className, dataTest = 'alert', ariaLabelIcon, type = 'h4', isClosable, ariaLabelClose, icon, onClose, link, automaticUnmount = true, scrollTo = false, scrollToError, ...other }) => {
    const [isFadeOut, setIsFadeOut] = React.useState(false);
    const alert = React.useRef(null);
    const scrollToErrorHook = (0, hooks_1.useScrollTo)({
        ...scrollToError?.hookProps,
    });
    let alertIcon = icon;
    const Component = type;
    (0, react_1.useEffect)(() => {
        if (scrollTo && alert.current) {
            alert.current.scrollIntoView({
                behavior: 'smooth',
                block: 'center',
            });
        }
    }, [scrollTo]);
    const defaultActionLinkMarkup = scrollToError?.enabled ? ((0, jsx_runtime_1.jsx)(link_1.Link, { type: "link", onClick: (e) => {
            e.preventDefault();
            scrollToErrorHook();
        }, className: "dsc-alert__link", underlined: true, children: scrollToError?.text })) : null;
    const titleMarkup = title && ((0, jsx_runtime_1.jsx)(Component, { className: "dsc-alert__title", "data-test": "title", children: title }));
    const descriptionMarkup = description && ((0, jsx_runtime_1.jsx)("small", { className: "dsc-alert__description", "data-test": "description", children: description }));
    const classes = (0, classnames_1.default)('dsc-alert', !children && 'is-noChildren', size === 'small' ? `is-${size}` : null, className, `is-${appearance}`, isFadeOut && 'is-fadeOut');
    const timeOutToken = parseInt(tokens_json_1.default['ad-long'].replace('ms', ''), 10);
    const handleCloseClick = () => {
        setIsFadeOut(true);
        setTimeout(() => {
            automaticUnmount && alert?.current && alert.current.remove();
            onClose?.();
        }, timeOutToken);
    };
    if (!alertIcon) {
        if (size === 'small') {
            switch (appearance) {
                case 'error':
                    alertIcon = (0, jsx_runtime_1.jsx)(FailureFilledXsmall_1.FailureFilledXsmall, { title: ariaLabelIcon });
                    break;
                case 'success':
                    alertIcon = (0, jsx_runtime_1.jsx)(SuccessFilledXsmall_1.SuccessFilledXsmall, { title: ariaLabelIcon });
                    break;
                case 'warning':
                    alertIcon = (0, jsx_runtime_1.jsx)(AttentionFilledXsmall_1.AttentionFilledXsmall, { title: ariaLabelIcon });
                    break;
                default:
                    alertIcon = (0, jsx_runtime_1.jsx)(InformationFilledXsmall_1.InformationFilledXsmall, { title: ariaLabelIcon });
            }
        }
        else {
            switch (appearance) {
                case 'error':
                    alertIcon = (0, jsx_runtime_1.jsx)(ErrorFieldFilled_1.ErrorFieldFilled, { title: ariaLabelIcon });
                    break;
                case 'success':
                    alertIcon = (0, jsx_runtime_1.jsx)(SuccessFilled_1.SuccessFilled, { title: ariaLabelIcon });
                    break;
                case 'warning':
                    alertIcon = (0, jsx_runtime_1.jsx)(AttentionFilled_1.AttentionFilled, { title: ariaLabelIcon });
                    break;
                default:
                    alertIcon = (0, jsx_runtime_1.jsx)(InfoFill_1.InfoFill, { title: ariaLabelIcon });
            }
        }
    }
    const iconMarkup = alertIcon && (0, jsx_runtime_1.jsx)("div", { className: "dsc-alert__icon", children: alertIcon });
    const closeButtonMarkup = isClosable && ((0, jsx_runtime_1.jsx)("button", { className: "dsc-alert__close", type: "button", onClick: handleCloseClick, children: (0, jsx_runtime_1.jsx)(Close_1.Close, { size: "small", title: ariaLabelClose }) }));
    const addClassToLink = (contentLink) => {
        const linkClassName = (0, classnames_1.default)(contentLink.props.className, 'dsc-alert__link');
        const linkProps = {
            className: linkClassName,
            underlined: true,
        };
        return React.cloneElement(contentLink, linkProps);
    };
    return ((0, jsx_runtime_1.jsx)("div", { ...other, className: classes, "data-test": dataTest, ref: alert, children: children || ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [iconMarkup, (0, jsx_runtime_1.jsxs)("div", { className: "dsc-alert__textContainer", children: [titleMarkup, descriptionMarkup, link && !scrollToError?.enabled && addClassToLink(link), defaultActionLinkMarkup] }), closeButtonMarkup] })) }));
};
exports.Alert = Alert;
exports.Alert.displayName = 'Alert';
//# sourceMappingURL=alert.js.map